( function( $ ) {
    var appliedIndividualCoupon = null;
    var $couponBtn = $('.woocommerce-checkout .js-coupon button.-coupon');
    var defaultButtonText = $couponBtn.text();

    $('.woocommerce-checkout .js-coupon input').on('keypress', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            if (appliedIndividualCoupon) {
                removeCoupon();
            } else {
                applyCoupon();
            }
        }
    });

    $('.woocommerce-checkout .js-coupon button.-coupon').on('click', function(e) {
        e.preventDefault();
        if (appliedIndividualCoupon) {
            removeCoupon();
        } else {
            applyCoupon();
        }
    });

    function applyCoupon() {
        $couponBtn.addClass('loading');
        var coupon_code = $('#coupon_code').val();

        $.ajax({
            url: junc_woocommerce_params.ajax_url,
            type: 'POST',
            data: {
                action: 'apply_coupon',
                security: junc_woocommerce_params.apply_coupon_nonce,
                coupon_code: coupon_code
            },
            success: function(response) {
                if (response.success) {
                    $('.js-coupon').find('.coupon-error-notice').remove();
                    $('#coupon-success-notice').remove();
                    $('<p>', {
                        id: 'coupon-success-notice',
                        class: 'coupon-success-notice',
                        text: response.data.message
                    }).appendTo('.js-couponInner');

                    $('.js-couponInput').addClass('has-success');

                    if (response.data.individual_use) {
                        appliedIndividualCoupon = coupon_code;
                        $couponBtn.text('Verwijderen');
                        $('#coupon_code').prop('readonly', true);
                        $('.js-coupon').addClass('is-applied');
                    } else {
                        $couponBtn.addClass('added');
                        $('#coupon_code').val('');

                        setTimeout(function() {
                            $couponBtn.removeClass('added');
                            $('.js-couponInput').removeClass('has-success');
                            $('#coupon-success-notice').remove();
                        }, 5000);
                    }

                    jQuery('body').trigger('update_checkout');
                } else {
                    $('#coupon-error-notice').remove();
                    $('<p>', {
                        id: 'coupon-error-notice',
                        class: 'coupon-error-notice',
                        text: response.data.message
                    }).appendTo('.js-couponInner');
                    $('.js-couponInput').addClass('has-error');
                    setTimeout(function() {
                        $('.js-coupon').find('.coupon-error-notice').remove();
                        $('.js-couponInput').removeClass('has-error');
                    }, 5000);
                }
            },
            error: function(xhr, status, error) {
                console.log("AJAX Error: " + error);
            },
            complete: function() {
                $couponBtn.removeClass('loading');
            }
        });
    }

    function removeCoupon() {
        $couponBtn.addClass('loading');

        $.ajax({
            url: junc_woocommerce_params.ajax_url,
            type: 'POST',
            data: {
                action: 'remove_coupon',
                security: junc_woocommerce_params.remove_coupon_nonce,
                coupon_code: appliedIndividualCoupon
            },
            success: function(response) {
                if (response.success) {
                    appliedIndividualCoupon = null;
                    $couponBtn.text(defaultButtonText);
                    $('#coupon_code').val('').prop('readonly', false);
                    $('.js-coupon').removeClass('is-applied');
                    $('.js-couponInput').removeClass('has-success');
                    $('#coupon-success-notice').remove();

                    jQuery('body').trigger('update_checkout');
                }
            },
            error: function(xhr, status, error) {
                console.log("AJAX Error: " + error);
            },
            complete: function() {
                $couponBtn.removeClass('loading');
            }
        });
    }

} ) ( jQuery );
